export default __webpack_public_path__ + "static/2-61f8937e4e7bf8796b0751f937e10a62.png";